import { useAuth } from '@/hooks/useAuth';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { AlertCircle, RefreshCw } from 'lucide-react';

export const InternalServerErrorPage = () => {
	const { clearAllAuth } = useAuth();

	const handleRetry = () => {
		clearAllAuth();
		window.location.reload();
	};

	return (
		<div className="min-h-screen bg-blue-50 flex items-center justify-center px-4">
			<Card className="w-full max-w-md shadow-lg">
				<CardHeader className="text-center">
					<div className="mx-auto w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mb-4">
						<AlertCircle className="w-6 h-6 text-red-600" />
					</div>
					<CardTitle className="text-xl font-semibold text-gray-900">
						Server Error
					</CardTitle>
				</CardHeader>
				<CardContent className="text-center space-y-6">
					<div className="space-y-2">
						<p className="text-gray-600">
							We're experiencing technical difficulties. Please try again in a
							few moments.
						</p>
						<p className="text-sm text-gray-500">
							If the problem persists, please contact support.
						</p>
					</div>

					<div className="flex flex-col gap-3">
						<Button onClick={handleRetry} className="w-full" variant="default">
							<RefreshCw className="w-4 h-4 mr-2" />
							Try Again
						</Button>
					</div>
				</CardContent>
			</Card>
		</div>
	);
};
